export default __webpack_public_path__ + "static/sintonizados-mobile-543ca528c21506db65a04f48dcc30b3a.png";